<script setup lang="ts">
// Mirrors Components/Controls/BaseSwitch.vue in the main callingly repo, so a
// switch reads the same in the phone app as it does in the dashboard. That one
// is built on headlessui, which this app doesn't carry, so the same geometry
// and colours are rebuilt over a plain checkbox: 44x24 track (lochmara-600 on,
// gray-200 off), a 20px white knob carrying a check/cross, 200ms.
defineProps<{
  modelValue: boolean
  label?: string
  disabled?: boolean
}>()

const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

const onChange = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).checked)
}
</script>

<template>
  <label
    class="flex items-center justify-between"
    :class="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
  >
    <span v-if="label" class="text-[#333]">{{ label }}</span>

    <input
      type="checkbox"
      class="peer sr-only"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChange"
    />

    <span
      class="relative inline-flex h-[24px] w-[44px] shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out peer-focus-visible:ring-2 peer-focus-visible:ring-[#2666a3] peer-focus-visible:ring-offset-2"
      :class="modelValue ? 'bg-[#2666a3]' : 'bg-[#e5e7eb]'"
    >
      <span
        class="pointer-events-none inline-flex h-[20px] w-[20px] items-center justify-center rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
        :class="modelValue ? 'translate-x-[20px]' : 'translate-x-0'"
      >
        <i class="material-icons text-[12px]! leading-none">{{ modelValue ? 'check' : 'close' }}</i>
      </span>
    </span>
  </label>
</template>
